class MediaClipbook extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-media-clipbook-grid]');
    this.cards = Array.from(this.querySelectorAll('[data-media-clipbook-card]'));
    this.filters = Array.from(this.querySelectorAll('[data-media-clipbook-filter]'));
    this.summary = this.querySelector('[data-media-clipbook-summary]');
    this.loadMoreContainer = this.querySelector('[data-media-clipbook-load-more]');
    this.activeFilter = 'all';
    this.perPage = Number(this.dataset.defaultPerPage || 24);
    this.visibleCount = this.perPage;
    this.buttonHoverClass = this.dataset.buttonHover || '';

    if (!this.grid || this.cards.length === 0) {
      return;
    }

    this.sortCards();
    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeFilter = button.dataset.mediaClipbookFilter || 'all';
        this.visibleCount = this.perPage;
        this.syncFilterButtons();
        this.render();
      });
    });

    this.syncFilterButtons();
    this.render();
  }

  sortCards() {
    this.cards.sort((left, right) => {
      const leftDate = left.dataset.mediaClipbookDate || '';
      const rightDate = right.dataset.mediaClipbookDate || '';
      return rightDate.localeCompare(leftDate);
    });

    this.cards.forEach((card) => {
      this.grid.appendChild(card);
    });
  }

  syncFilterButtons() {
    this.filters.forEach((button) => {
      const isActive = (button.dataset.mediaClipbookFilter || 'all') === this.activeFilter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  filteredCards() {
    if (this.activeFilter === 'all') {
      return this.cards;
    }

    return this.cards.filter((card) => card.dataset.mediaClipbookCategory === this.activeFilter);
  }

  render() {
    const visibleCards = this.filteredCards();
    const total = visibleCards.length;
    const showCount = Math.min(this.visibleCount, total);
    const shownCards = new Set(visibleCards.slice(0, showCount));

    this.cards.forEach((card) => {
      card.hidden = !shownCards.has(card);
    });

    if (this.summary) {
      if (total === 0) {
        this.summary.textContent = 'No media appearances match this filter.';
      } else if (showCount >= total) {
        this.summary.textContent = `Showing all ${total} items`;
      } else {
        this.summary.textContent = `Showing ${showCount} of ${total} items`;
      }
    }

    this.renderLoadMore(showCount < total);
  }

  renderLoadMore(hasMore) {
    if (!this.loadMoreContainer) {
      return;
    }

    this.loadMoreContainer.innerHTML = '';

    if (!hasMore) {
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = ['media-clipbook__load-more', 'btn', 'btn--secondary', this.buttonHoverClass]
      .filter(Boolean)
      .join(' ');
    button.textContent = 'Load more';
    button.addEventListener('click', () => {
      this.visibleCount += this.perPage;
      this.render();
    });
    this.loadMoreContainer.appendChild(button);
  }
}

if (!customElements.get('media-clipbook')) {
  customElements.define('media-clipbook', MediaClipbook);
}
